angular
  .module('components')

  .factory('TitleCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class TitleCrud extends Crud {
        constructor(list) {
          super(
            'titles' + (list || ''),
            '@@apiUrl' + '/personTitles' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return TitleCrud;
    }
  ]);
